module.exports = __webpack_public_path__ + "img/inco3.bdec32a7.png";